import { render } from "./ResultSuccess.vue?vue&type=template&id=6448b1f1&ts=true"
import script from "./ResultSuccess.vue?vue&type=script&lang=ts"
export * from "./ResultSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__